import { useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { joinProgramWaitlist } from "@/lib/checkout";
import { inputCls } from "@/components/registration/ui";

export default function InlineWaitlist({ offering }) {
  const [form, setForm] = useState({ athlete_name: "", parent_name: "", email: "", phone: "" });
  const [state, setState] = useState({ busy: false, done: false, error: "" });
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const submit = async () => {
    if (!form.athlete_name.trim() || !form.parent_name.trim() || !/.+@.+\..+/.test(form.email)) {
      setState({ busy: false, done: false, error: "Athlete name, parent name and a valid email are required." });
      return;
    }
    setState({ busy: true, done: false, error: "" });
    try {
      await joinProgramWaitlist({ program_id: offering.id, ...form });
      setState({ busy: false, done: true, error: "" });
    } catch (e) {
      setState({ busy: false, done: false, error: e?.response?.data?.detail || "Something went wrong." });
    }
  };
  if (state.done) {
    return <p data-testid="waitlist-success" className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-emerald-300"><Check size={16} /> You're on the waitlist. We'll email you if a spot opens.</p>;
  }
  return (
    <div data-testid="inline-waitlist" className="mt-5 space-y-3">
      <p className="text-sm font-semibold text-white/70">This session is full. Join the waitlist and we'll email you if a spot opens.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <input data-testid="wl-athlete-name" value={form.athlete_name} onChange={(e) => set("athlete_name", e.target.value)} placeholder="Athlete name *" className={inputCls} />
        <input data-testid="wl-parent-name" value={form.parent_name} onChange={(e) => set("parent_name", e.target.value)} placeholder="Parent / guardian name *" className={inputCls} />
        <input data-testid="wl-email" type="email" value={form.email} onChange={(e) => set("email", e.target.value)} placeholder="Email *" className={inputCls} />
        <input data-testid="wl-phone" value={form.phone} onChange={(e) => set("phone", e.target.value)} placeholder="Phone" className={inputCls} />
      </div>
      {state.error && <p data-testid="wl-error" className="text-sm font-semibold text-red-400">{state.error}</p>}
      <button data-testid="wl-submit-btn" onClick={submit} disabled={state.busy} className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full border border-white/30 text-white font-bold px-7 py-3.5 hover:bg-white/10 transition-colors">
        {state.busy ? <Loader2 size={16} className="animate-spin" /> : "Join Waitlist"}
      </button>
    </div>
  );
}
